__turbopack_context__.v({
  "body": "modal-module-scss-module__zxRfSG__body",
  "close": "modal-module-scss-module__zxRfSG__close",
  "container": "modal-module-scss-module__zxRfSG__container",
  "dialog": "modal-module-scss-module__zxRfSG__dialog",
  "footer": "modal-module-scss-module__zxRfSG__footer",
  "heading": "modal-module-scss-module__zxRfSG__heading",
  "medium": "modal-module-scss-module__zxRfSG__medium",
  "overlay": "modal-module-scss-module__zxRfSG__overlay",
  "primary": "modal-module-scss-module__zxRfSG__primary",
  "responsive-image": "modal-module-scss-module__zxRfSG__responsive-image",
  "secondary": "modal-module-scss-module__zxRfSG__secondary",
  "small": "modal-module-scss-module__zxRfSG__small",
  "x": "modal-module-scss-module__zxRfSG__x",
});
